import React from "react";

/**
 * Bootstrap button. theme prop maps to btn-{theme}.
 * size prop maps to btn-{size} (sm, lg).
 */
const Button = ({ theme = "primary", size, outline = false, pill = false, className = "", style, children, ...rest }) => {
  const variant = outline ? `btn-outline-${theme}` : `btn-${theme}`;
  const cls = ["btn", variant, size && `btn-${size}`, pill && "btn-pill", className].filter(Boolean).join(" ");
  return (
    <button className={cls} style={style} {...rest}>
      {children}
    </button>
  );
};

export default Button;

/** Bootstrap btn-group wrapper. */
export const ButtonGroup = ({ className = "", children, ...rest }) => (
  <div className={["btn-group", className].filter(Boolean).join(" ")} role="group" {...rest}>
    {children}
  </div>
);

/** Bootstrap btn-toolbar wrapper. */
export const ButtonToolbar = ({ className = "", children, ...rest }) => (
  <div className={["btn-toolbar", className].filter(Boolean).join(" ")} role="toolbar" {...rest}>
    {children}
  </div>
);
